<template>
    <div>
        <b-modal
            id="editStudent"
            title="Editar Aluno"
            hide-footer>
            <b-overlay :show="loading" rounded="sm">
                <b-form @submit="submit" @submit.stop.prevent>

                    <!-- Field -->
                    <b-form-group
                        v-if="matriculation"
                        label="Matrícula">
                        <!-- Input -->
                        <b-form-input
                            v-model="form.matriculation"
                            :state="hasErrors('matriculation', errors)"
                        ></b-form-input>

                        <!-- Error -->
                        <has-errors :errors="errors" name="matriculation" />
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        label="Nome">
                        <!-- Input -->
                        <b-form-input
                            v-model="form.name"
                            :state="hasErrors('name', errors)"
                        ></b-form-input>

                        <!-- Error -->
                        <has-errors :errors="errors" name="name" />
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        label="Email">
                        <!-- Input -->
                        <b-form-input
                            v-model="form.email"
                            :state="hasErrors('email', errors)"
                        ></b-form-input>

                        <!-- Error -->
                        <has-errors :errors="errors" name="email" />
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        label="Telefone">
                        <!-- Input -->
                        <the-mask
                            type="tel"
                            :mask="['(##) #####-####', '(##) ####-####']"
                            v-model="form.phone"
                            class="form-control"
                        ></the-mask>

                        <!-- Error -->
                        <has-errors :errors="errors" name="phone" />
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        label="Data de Nascimento">
                        <!-- Input -->
                        <b-form-input
                            type="date"
                            v-model="form.birth"
                            :state="hasErrors('birth', errors)"
                        ></b-form-input>

                        <!-- Error -->
                        <has-errors :errors="errors" name="birth" />
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        label="Gênero">

                        <b-form-radio v-model="form.genre" name="genre" value="M">Masculino</b-form-radio>
                        <b-form-radio v-model="form.genre" name="genre" value="F">Feminino</b-form-radio>
                        <b-form-radio v-if="genreAdvanced" v-model="form.genre" name="genre" value="MC">Mulher Cis</b-form-radio>
                        <b-form-radio v-if="genreAdvanced" v-model="form.genre" name="genre" value="MT">Mulher Trans</b-form-radio>
                        <b-form-radio v-if="genreAdvanced" v-model="form.genre" name="genre" value="HC">Homem Cis</b-form-radio>
                        <b-form-radio v-if="genreAdvanced" v-model="form.genre" name="genre" value="HT">Homem Trans</b-form-radio>
                        <b-form-radio v-if="genreAdvanced" v-model="form.genre" name="genre" value="NB">Não-Binárie</b-form-radio>
                        <b-form-radio v-model="form.genre" name="genre" value="O">Outro</b-form-radio>

                        <!-- Error -->
                        <has-errors :errors="errors" name="genre" />
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        label="Observação"
                        description="Aqui você pode colocar uma observação do aluno para que os corretores possam saber previamente algum detalhe antes de corrigir.">
                        <!-- Input -->
                        <b-textarea
                            v-model="form.observation"
                            :state="hasErrors('observation', errors)"
                        ></b-textarea>

                        <!-- Error -->
                        <has-errors :errors="errors" name="observation" />
                    </b-form-group>

                    <!-- Submit -->
                    <b-button type="submit" variant="primary" :disable="loading">
                        Editar Aluno
                    </b-button>
                </b-form>
            </b-overlay>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: ['matriculation', 'genreAdvanced'],
    data() {
        return {
            loading: false,
            errors: {},
            studentId: null,
            form: {
                matriculation: null,
                name: null,
                email: null,
                phone: null,
                genre: null,
                birth: null,
                organization: null
            }
        }
    },
    created() {
        this.$root.$on('editStudent', (student) => {

            this.studentId = student.id;

            this.form.matriculation = student.matriculation;
            this.form.name = student.name;
            this.form.email = student.email;
            this.form.phone = student.phone;
            this.form.genre = student.genre;
            this.form.birth = student.birth;
            this.form.observation = student.observation

            this.$bvModal.show('editStudent')
        });
    },
    methods: {

        submit() {
            this.loading = true;
            axios.put('/teacher/students/' + this.studentId + '/basic' , this.form)
                .then((result) => {

                    // Callback
                    this.$emit('updated')

                    // Close Modal
                    this.$bvModal.hide('editStudent')

                    // Message
                    this.$toast.success('Aluno editado com sucesso !')

                    // Clear Form
                    this.form = {
                        matriculation: null,
                        name: null,
                        email: null,
                        phone: null,
                        genre: null,
                        birth: null,
                        organization: null
                    }

                    // Clear Errors
                    this.errors = {}
                })
                .catch((errors) => {

                    // Check Errors
                    this.errors = this.setErrors(errors)

                })
                .finally(() => this.loading = false)
        },
    }
}
</script>

<style scoped>

</style>
